import React from 'react';

export default {
    fields: [
        {
            type: "homepageItemOptions",
            name: "type",

            props: {
                label: <p><i className="asterisk icon inline"/>Select the type to add?</p>
            }
        },
        {
          key: "AddHomepageItemTypeSwitch",
          subSection: true,
          viewSwitch: (formProxy) => {
            return formProxy ? formProxy.currentBaseResource.type : '';
          },
          viewCases: {
            BREAK_GROUP: [
              {
                type: 'number',
                name: 'numBreaks',
                required: true,
                props: {
                  label: 'Number of Breaks',
                  min: 2,
                  max: 5
                }
              },
              {
                type: "radio",
                name: "sponsoredType",

                props: {
                    label: <p><i className="asterisk icon inline"/>What kind of breaks?</p>,
                    options: [
                        {key: 'editorial', text: 'Editorial', value: 'editorial'},
                        {key: 'sponsored', text: 'Sponsored', value: 'sponsored'}
                    ]
                }
              }
            ],
            HERO: [

            ],
            MESSAGE_BAR: [

            ]
          }

        } // end viewSwitch
    ]
};



// WEBPACK FOOTER //
// ./public/components/homepage-layouts/items/AddItemModal/addHomepageItemFormConfig.js